/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgExtScanAvailableModel } from '../../models/org-ext-scan-available-model';

export interface OrgExtAvailableOrganizationIdPersonIdGet$Params {
  organizationId: string;
  personId: string;
}

export function orgExtAvailableOrganizationIdPersonIdGet(http: HttpClient, rootUrl: string, params: OrgExtAvailableOrganizationIdPersonIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<OrgExtScanAvailableModel>> {
  const rb = new RequestBuilder(rootUrl, orgExtAvailableOrganizationIdPersonIdGet.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('personId', params.personId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<OrgExtScanAvailableModel>;
    })
  );
}

orgExtAvailableOrganizationIdPersonIdGet.PATH = '/OrgExt/Available/{organizationId}/{personId}';
